export default __webpack_public_path__ + "static/media/1.36a8145f.jpg";